import * as React from "react";

import { PlayerAccount, VideoCatalystStatus } from "@/interfaces";
import { fullNameFrom, extractInitials } from "@/utils";
import { Avatar } from "@/components/ui";

interface Props {
  playerInfo?: PlayerAccount;
  showPhone?: boolean;
  videoCatalystStatus?: VideoCatalystStatus;
  industryRole?: string;
}

const PlayerInfoSectionFC: React.FC<Props> = ({ playerInfo, showPhone, videoCatalystStatus, industryRole }) => {
  const creditsUsedLabel = () => {
    if (!videoCatalystStatus || !playerInfo) return null;

    let { creditsUsed, unlimitedCredits, creditsAllotted } = videoCatalystStatus;
    creditsUsed = creditsUsed || 0;
    let totalCredits = unlimitedCredits ? "∞" : creditsAllotted;

    return `${creditsUsed}/${totalCredits} credits used`;
  };

  return (
    <div className="flex flex-row items-center gap-4 py-4 select-none w-full text-left">
      <Avatar className="size-16 border border-slate-200 shadow-sm shrink-0">
        <Avatar.Image src={playerInfo?.photoUrl || undefined} />
        <Avatar.Fallback className="text-lg font-bold text-slate-500 bg-slate-100">
          {playerInfo ? extractInitials(playerInfo.firstName, playerInfo.lastName) : ""}
        </Avatar.Fallback>
      </Avatar>
      <div className="flex flex-col text-sm text-slate-500 font-sans gap-0.5 min-w-0">
        <div className="font-bold text-base text-slate-800 leading-snug truncate">
          {playerInfo ? fullNameFrom(playerInfo) : ""}
        </div>
        {industryRole && <div className="font-medium text-slate-600 truncate leading-tight">{industryRole}</div>}
        <div className="truncate leading-tight hover:underline cursor-pointer">
          {playerInfo ? playerInfo.email : ""}
        </div>
        {showPhone && playerInfo?.phone && <div className="leading-tight">{playerInfo.phone}</div>}
        {videoCatalystStatus && (
          <div className="font-medium text-slate-700 leading-tight mt-0.5">{creditsUsedLabel()}</div>
        )}
      </div>
    </div>
  );
};

export const PlayerInfoSection = PlayerInfoSectionFC;
